'use strict'
import { App } from '../config/app.js'
import { default as Component } from '../component.js'
import { hasRole, currentStore, getNetworkFromCreditCardNumber, loadScript } from '../helper.js'

class FormCreditCard extends Component
{
	async init()
	{
		this.element.querySelectorAll('input, select').forEach(el =>
		{
			el.addEventListener('input', e => this.onInput(e))
			el.addEventListener('change', e => this.onChange(e))
		});		
		
		if (hasRole('Patient') && !window.Stripe && !window.StripeRequested)
		{
			window.StripeRequested = true
			await loadScript('https://js.stripe.com/v2/')
			Stripe.setPublishableKey(currentStore('stripeApiKey'))
			delete window.StripeRequested
		}
		this.tokenEl = this.element.querySelector('[name*="token"')
		this.numberEl = this.element.querySelector('[name*="number"')
		this.monthEl = this.element.querySelector('[name*="expirationMonth"')
		this.yearEl = this.element.querySelector('[name*="expirationYear"')
		this.cvcEl = this.element.querySelector('[name*="cvc"')
		this.tokenEl = this.element.querySelector('[name*="token"')
		this.networkEl = this.element.querySelector('[name*="network"')
	}
	onInput()
	{
		this.tokenNeedsUpdate = true
		this.tokenEl.value = ''
	}
	onChange(e)
	{
		if (this.isFetchingToken)
			return

		if (e.target === this.numberEl)
			this.networkEl.value = getNetworkFromCreditCardNumber(this.numberEl.value)

		if ((e.target === this.monthEl || e.target === this.yearEl) && (this.monthEl.value && this.yearEl.value))
		{
			const now = new Date()
			const expDate = new Date(this.yearEl.value, this.monthEl.value)
			if (now >= expDate)
			{
				this.monthEl.classList.add(App.cssClass.invalid)
				this.yearEl.classList.add(App.cssClass.invalid)
				this.monthEl.focus()
				return
			}
			else
			{
				this.monthEl.classList.remove(App.cssClass.invalid)
				this.yearEl.classList.remove(App.cssClass.invalid)
			}
		}

		if (!this.numberEl.value || !this.monthEl.value || !this.yearEl.value || !this.cvcEl.value)
			return

		if (hasRole('Patient') && !this.isFetchingToken && this.tokenNeedsUpdate)
		{
			this.isFetchingToken = true
			this.element.classList.add(App.cssClass.loading)
			Stripe.card.createToken(
				{
					number: this.numberEl.value,
					cvc: this.cvcEl.value,
					exp_month: this.monthEl.value,
					exp_year: this.yearEl.value
				},
				(_status, response) =>
				{
					this.isFetchingToken = false
					this.tokenNeedsUpdate = false
					this.element.classList.remove(App.cssClass.loading)
					this.element.querySelectorAll('input, select')
						.forEach(el => el.classList.remove('invalid'))
					if (response.error)
					{
						let errorEl;
						if (response.error.param === 'number')
							errorEl = this.numberEl
						else if (response.error.param === 'cvc')
							errorEl = this.cvcEl
						else if (response.error.param === 'exp_month')
							errorEl = this.monthEl
						else if (response.error.param === 'exp_year')
							errorEl = this.yearEl

						errorEl.classList.add(App.cssClass.invalid)
						errorEl.focus()
						App.UI.AlertError(response.error.message)
					}
					else
					{
						this.tokenEl.value = response.id
						if (this.tokenCallBack)
							this.tokenCallBack()
					}
				})
		}		
	}
	setTokenCallBack(callBack)
	{
		this.tokenCallBack = callBack
	}
}

export default FormCreditCard
